import { configureStore } from '@reduxjs/toolkit'
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux'
import clicksReducer from '../slice/clicksSlice'
import notebookReducer from '../slice/notebookSlice'
import notebooksReducer from '../slice/notebooksSlice'
import notesReducer from '../slice/notesSlice'
import noteReducer  from '../slice/noteSlice'
//import homeReducer from '../slice/homeSlice'


export const store =  configureStore({
  reducer: {
    //counter: counterReducer,
    notebook: notebookReducer,
    notebooks: notebooksReducer,
    note:noteReducer,
    notes: notesReducer,
    clicks: clicksReducer,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

// Export pre-typed hooks to use throughout the app (fixes redux-typescript issues)
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
//export type AppStore = typeof store
